export default "__VITE_ASSET__B4WsgssY__$_?url__"